if(typeof BSS_B2B != undefined) {
  if (window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      const targetCart = document.querySelector(".cart__summary");
      if (targetCart) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          for (const record of recordList) {
            if (record.target.id === "cart-summary") {
                console.log(123);       
                BSS_B2B.observer.cartSubject.listenCartCheckout();
              break;
            }
          }
        });
        mutationObserver.observe(targetCart, { childList: true, subtree: true });
      }
    }, 3000)
  }
  
}

/* Stretchtent-Shop 9 okt 2026 - TIJDELIJK.
   BSS plaatst de tekst "null" in het besteloverzicht van de winkelwagen sinds het
   btw-vak van BSS is uitgezet (btw-nummer gaat nu via de Shopify-checkout).
   Dit blok haalt alleen die losse tekst weg. Verwijderen zodra BSS het heeft opgelost. */
(function () {
  if (!window.location.pathname.includes('/cart')) return;
  function cleanNull() {
    var root = document.getElementById('cart-summary');
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), node, dead = [];
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === 'null') dead.push(node);
    }
    dead.forEach(function (t) { t.remove(); });
  }
  function start() {
    cleanNull();
    new MutationObserver(cleanNull).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
